module.exports = __webpack_public_path__ + "static/media/bed_new_pack_cat_FR_285x285.e385b952.png";